<template>
  <div class="p-3"> 
    <b-table striped hover :items="rowdata" :fields="fields"></b-table>
<v-client-table ref="table" :columns="columns" :data="TblData" :options="options" v-if="TblData.length>0">  
  <div slot="beforeTable"  class="form-group row VueTables_Adduser Maintitle mr-1 ml-1"> 
          <div class="col-4 float-left mt-1 pl-1">
            <strong>EDS Criteria</strong>
          </div> 

        </div>
</v-client-table> 
  </div>
</template>

<script>
 import Vue from 'vue';
    import {mapGetters} from 'vuex'
    import moment from 'moment'
    import axios from 'axios'
    import Datepicker from 'vuejs-datepicker';
    import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
    import Subtitle from '@/Common/Default/SubTitle.vue';
    import Modal from '@/Common/ModelPop.vue';
    import Card from "@/Common/Card.vue";
    import CardBody from "@/Common/CardBody.vue";
    import TileNote from "@/Common/TileNote.vue";
    import { PopUpVariant } from '@/Common/Default/PopUpVariant';
    import { request } from 'http';
    import Vuelidate from 'vuelidate'
    import {helpers, required, minLength, sameAs, not, maxLength, numeric, integer, between} from 'vuelidate/lib/validators'
    import { ref } from 'vue' 
    const checkedNames = ref([]);
export default {
    props:
    {
      useredsid: 0, 
      tblRow: 0
    },
    data: function () {
    return {
      fields: [
    
        //expirydate
          {
            key: 'usertype',
            label: 'User Type', 
          },
          {
            key: 'eds',
            label: 'Brand/Generic Name',
            //sortable: false
          },
          {
            key: 'dosage',
            label: 'Dosage', 
          },
          {
            key: 'din',
            label: 'Din',
            //sortable: true,
            // Variant applies to the whole column, including the header and footer
            //variant: 'danger'
          },
          {key:'effectivedate', label :'Effective Date' ,formatter: "momentdate" },
        {key:'expirydate', label :'Expiry Date' ,formatter: "momentdate" },
        ],
        // fields: [
        //   {
        //     key: 'usertype',
        //     label: 'User Type', 
        //   },
        //   {
        //     key: 'eds',
        //     label: 'Brand/Generic Name',
        //     //sortable: false
        //   },
        //   {
        //     key: 'dosage',
        //     label: 'Dosage', 
        //   },
        //   {
        //     key: 'din',
        //     label: 'Din',
        //     //sortable: true,
        //     // Variant applies to the whole column, including the header and footer
        //     //variant: 'danger'
        //   }
        // ],
    
    rowdata  : [], 
    allMarked:false,
    markedRows:[], 
    TblData: [],
    columns: ['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter',
              'commentallow','allowexpedit','openexpdate','createdby','modifyby'],
    //columns: ['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter',
    //'commentallow','createdby','modifyby'],
    options: {
      texts:{
        //count:"Showing {from} to {to} of {count} records|{count} records|One record",
        first:'First',
        last:'Last',
        //limit:"Records:",
        //page:"Page:",
        noResults:"No Criteria Record Found",
        filterBy:"Filter by {column}",
        loading:'Loading...',
        defaultOption:'Select {column}',
        columns:'Columns'
      },
      headings: { 
        id:"Select Criteria",
        //status: "Status",
        diagnosis: "Diagnosis",
        criteria: "Criteria",
        maxedunit: "Max Unit",
        maxedslength: "Max Length",
        minage:"Min Age",
        maxage:"Max Age",
        generateletter:"Generate Letter",
        commentallow:"Comment Allow",
        allowexpedit: "Expiry Date Editable",
        openexpdate: "Open Expiry Date",
        createdby: "Created By",
        modifyby: "Modify By"
      },

      responseAdapter({data}) {
        return {
          data: formatData,
          count: data.length
        };
      },
      summary: false,
      caption: false,
      perPage:5,
      perPageValues:[5],
      dateColumns:['effectivedate','expirydate'],
      footerHeadings: false,
      filterable: true,

      // listColumns: {
      //   claimtype: [
      //     {id: "CL",
      //     text: "Claim"},
      //     {id: "PA",
      //     text: "Prior Approval"}
      //   ]
      // },

      templates: { 
        status(h, row) {
            if(row.status ==true)
            return "Active"
        else
        return  "Inactive"
        },
        commentallow(h, row) {
            if(row.commentallow == 'N')
            return "Not Allowed"
        else if(row.commentallow == 'R') // Optional
        return  "Required"
        else if(row.commentallow == 'O') // Optional
        return  "Optional"
        },  

        maxedunit(h, row) {
            if(row.maxedunit == 'D')
            return "Days"
        else if(row.maxedunit == 'M') // Optional
        return  "Month"
        else if(row.maxedunit == 'Y') // Optional
        return  "Year"
        }, // maxedunit

        generateletter(h, row) {
            if(row.generateletter ==true)
            return "YES"
        else
        return  "NO"
        },
        allowexpedit(h, row) {
            if(row.allowexpedit ==true)
              return "YES"
            else
              return  "NO"
        },
        openexpdate(h, row) {
            if(row.openexpdate ==true)
              return "YES"
            else
              return  "NO"
        },
        effectivedate(h, row) {
          return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');
        },
        expirydate(h, row) {
          return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');
        },
    
      },


     pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','commentallow','allowexpedit','openexpdate','createdby','modifyby'],
          filterable: '',//['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','commentallow','createdby','modifyby'],
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
    },
    }
    },
    filters: {
          moment: function (date) {
            return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
          stringify(value) {
            return JSON.stringify(value, null, 2)
          }  
        }, 
        computed: {
    currentRouteName() {
        return this.$route.name;
    }
},
    methods: 
    {
      momentdate: function (date) {
            return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
      ClearAll() {
      //this.selectedOptions = [];
      // this.$emit('change', {
      //   changed: null,
      //   selected: []
      // });
      this.$emit("exitpage", "EDSID");
    },

    Exit() {
      //this.selectedOptions = [];
      // this.$emit('change', {
      //   changed: null,
      //   selected: []
      // });
      this.$emit("criteriadone", "");
    },

    GetUserEds(){
      //console.log('eds id =  '+ this.useredsid)
          var vm = this;      
          vm.searched = false;
          var params = new URLSearchParams();            
           params.append('edsrec',  this.useredsid);         
           axios.get('SaskHealthApi/Codes/GetUsersEDSAllocation?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
           .then(function (response) {
               //vm.TblData=response.data; 
               //var r   = JSON.parse(JSON.stringify(response.data))
                vm.rowdata.push(response.data[0])
                //console.log(vm.rowdata)             
            })
            .catch(function (er) {
                //console.log(er)
            });
          },

    loadTable()
    {

    var vm = this;
    vm.searched = false;
    var params = new URLSearchParams();
     params.append('usergroupid', this.tblRow.id);
     //params.append('usergroupid', this.useredsid);
     axios.get("SaskHealthApi/Codes/GetEDSCriteria", {headers: { Authorization: "Bearer " + localStorage.access_token },params,})
    .then(function (response) {
         vm.TblData=response.data;

      })
      .catch(function (er) {
                    //console.log(er)
                }).then(function () {

                  vm.markedRows=[];
                   // vm.tableData.push(response.data);
                  //  for(let i = 0; i <  vm.TblData.length; i++){
                  //       ////console.log(vm.TblData[i].id)
                  //       if(vm.TblData[i].id>0)
                  //       {
                  //         // alert(vm.tableData[i].haspermission)
                  //           vm.markedRows.push(vm.TblData[i].id);
                  //       }
                  //   }

                    ////console.log('at fill ' + vm.markedRows)
                }); 
    },
    showMsg(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: 'Close',
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true,
      })
        .then(value => {


          this.boxTwo = this.msg;
          if(value)
          { 
            this.$emit("exitpage", this.currentRouteName);
            // this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            //   //console.log('Modal is about to be shown', bvEvent, modalId)
            // })
            //this.$route.push("EDSStandard")
              //console.log(value)
          }
        })
        .catch(err => {
          // An error occurred
        })
    
    },
},


    created: function() {
            console.log(this.tblRow)
            var r   = JSON.parse(JSON.stringify(this.tblRow))
            this.rowdata.push(r)
            //console.log(this.rowdata)
            //this.GetUserEds();
             this.AppServiceID = 1;//this.Type;

             if(this.AppServiceID == 3)
             {
               this.AppName = "Optical";
             }
             else if(this.AppServiceID == 4)
             {
               this.AppName = "Hearing";
             }
             else if(this.AppServiceID == 5)
             {
               this.AppName = "Podiatry";
             }

             this.DateFormat = this.$store.getters.GetDateFormat;
             this.loadTable();
           },

           beforeCreate: function() {

           },

           mounted: function () {
    
            // this.$root.$on('loadctr', () => {
            //   //console.log('listening')
              //this.loadTable();
              //})

             // var params = new URLSearchParams();
             // var vm = this;

             // axios.get('SaskHealthApi/Codes/IsAssessorOrSuper?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             // .then(function (response) {
             //     // //console.log(response.data);
             //   vm.isAssessor = response.data;
             //     vm.GetUserClinics();
             //     vm.GetProviders();
             // }).catch(function (er) {
             //   //console.log(er)
             // });


           },
}
</script>

<style>
@import url(//netdna.bootstrapcdn.com/font-awesome/4.2.0/css/font-awesome.css);

/*** basic styles ***/
/* 
body { margin: 20px; }
h1 { font-size: 1.5em; }
label { font-size: 18px; }
container {
  width: 175px;
  margin-left: 20px;
} */

input[type=radio].with-font,
input[type=checkbox].with-font {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

input[type=radio].with-font ~ label:before,
input[type=checkbox].with-font ~ label:before {
    font-family: FontAwesome;
    display: inline-block;
    content: "\f1db";
    letter-spacing: 10px;
    font-size: 1.2em;
    color: #535353;
    width: 1.4em;
}

input[type=radio].with-font:checked ~ label:before,
input[type=checkbox].with-font:checked ~ label:before  {
    content: "\f00c";
    font-size: 1.2em;
    color: darkgreen;
    letter-spacing: 5px;
}
input[type=checkbox].with-font ~ label:before {
    content: "\f096";
}
input[type=checkbox].with-font:checked ~ label:before {
    content: "\f046";
    color: darkgreen;
}
input[type=radio].with-font:focus ~ label:before,
input[type=checkbox].with-font:focus ~ label:before,
input[type=radio].with-font:focus ~ label,
input[type=checkbox].with-font:focus ~ label
{
    color: green;
}

.checkbox label:after {
  content: '';
  display: table;
  clear: both;
}

.checkbox .cr {
  position: relative;
  display: inline-block;
  border: 1px solid #a9a9a9;
  border-radius: .25em;
  width: 1.2em;
  height: 1.2em;
  /* float: left; */
  margin-right: .5em;
}

.checkbox .cr .cr-icon {
  position: absolute;
  font-size: .7em;
  line-height: 0;
  top: 50%;
  left: 15%;
}

.checkbox label input[type="checkbox"] {
  display: none;
}

.checkbox label input[type="checkbox"]+.cr>.cr-icon {
  opacity: 0;
}

.checkbox label input[type="checkbox"]:checked+.cr>.cr-icon {
  opacity: 1;
}

.checkbox label input[type="checkbox"]:disabled+.cr {
  opacity: .5;
}


</style>
